import React from 'react';
import PropTypes from 'prop-types';

/**
 * TagBlock
 *  - Block that display main title
 */
export function TagBlock(props) {
  return <div className={props.className}>{props.children}</div>;
}

TagBlock.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * Tag component to display in the block
   */
  children: PropTypes.element,
};

TagBlock.defaultProps = {
  className: '',
  color: '#fff',
};
